let videoButton = document.querySelectorAll("[element='videoButton']");

let videoComponent = document.querySelector(`.video_modal`);
let videoBackground = videoComponent.querySelector(".video_background");
let videoWrap = videoComponent.querySelector(".video_tab-body");
let videoClose = videoComponent.querySelector(".close-button");
let videoTabMenu = videoComponent.querySelector(".video_tab-menu");

function pauseAllVideos() {
  const videos = document.querySelectorAll("video");
  videos.forEach((video) => {
    video.pause();
  });
}

let openVideoAnimation = gsap.timeline({ paused: true });
openVideoAnimation
  .set(videoComponent, { display: "flex" })
  .from(videoBackground, {
    backgroundColor: "rgba(0, 0, 0, 0)",
    duration: 0.35,
    ease: "power1.inout",
  })
  .from(
    videoWrap,
    {
      opacity: 0,
      scale: 0.975,
      clipPath: "inset(50% 50% 50% 50%)",
      duration: 0.35,
      ease: "power4.inout",
    },
    "<"
  )
  .from(videoTabMenu, {
    opacity: 0,
    duration: 0.35,
    ease: "power4.inout",
    y: "100%",
  });

videoButton.forEach((el) => {
  el.addEventListener("click", () => {
    openVideoAnimation.play();
    document.querySelector("body").style.overflow = "hidden";
  });
});

videoBackground.addEventListener("click", () => {
  openVideoAnimation.reverse();
  pauseAllVideos();
  document.querySelector("body").style.overflow = "auto";
});

videoClose.addEventListener("click", () => {
  openVideoAnimation.reverse();
  pauseAllVideos();
  document.querySelector("body").style.overflow = "auto";
});

document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".video_tab-link");
  const tabContents = document.querySelectorAll(".video_video");
  let currentVideo = null;

  tabLinks.forEach((link, index) => {
    link.addEventListener("click", () => {
      // Pause the current video (if it exists)
      if (currentVideo) {
        currentVideo.pause();
      }

      // Remove 'is--active' class from all tab links and contents
      tabLinks.forEach((tabLink) => tabLink.classList.remove("is--active"));
      tabContents.forEach((content) => content.classList.remove("is--active"));

      // Add 'is--active' class to the clicked tab link and corresponding content
      link.classList.add("is--active");
      tabContents[index].classList.add("is--active");

      // Set the current video to the newly activated video
      currentVideo = tabContents[index].querySelector("video");
    });
  });

  // Make the first tab active by default
  tabLinks[0].click();
});
